window.i18n_en = {
  "general": {
    "accessibility": {
      "skip_to_content": "Skip to content",
      "close_modal": "Close",
      "link_messages": {
        "new_window": "Opens in a new window.",
        "external": "Opens external website.",
        "new_window_and_external": "Opens external website in a new window."
      },
      "refresh_page": "Choosing a selection results in a full page refresh.",
      "selection_help": "Press the space key then arrow keys to make a selection.",
      "unit_price_separator": "per",
      "error": "Error"
    },
    "meta": {
      "tags": "Tagged \"{{ tags }}\"",
      "page": "Page {{ page }}"
    },
    "404": {
      "title": "404 Page Not Found",
      "subtext": "The page you requested does not exist.",
      "link": "Continue shopping"
    },
    "pagination": {
      "previous": "Previous page",
      "next": "Next page",
      "current_page": "Page {{ current }} of {{ total }}"
    },
    "password_page": {
      "opening_soon": "Opening Soon",
      "login_form_heading": "Enter store using password",
      "login_form_password_label": "Password",
      "login_form_password_placeholder": "Your password",
      "login_form_submit": "Enter",
      "signup_form_email_label": "Email",
      "signup_form_success": "We will send you an email right before we open!",
      "admin_link_html": "Are you the store owner? <a href=\"/admin\" class=\"text-link\">Log in here</a>",
      "password_link": "Enter using password"
    },
    "social": {
      "share_on_facebook": "Share",
      "share_on_twitter": "Tweet",
      "share_on_pinterest": "Pin it",
      "alt_text": {
        "share_on_facebook": "Share on Facebook",
        "share_on_twitter": "Tweet on Twitter",
        "share_on_pinterest": "Pin on Pinterest"
      }
    },
    "search": {
      "no_results": "Try checking your spelling or using different words.",
      "empty_search_message": "Search field cannot be empty",
      "results_with_count": {
        "one": "{{ count }} result for “{{ terms }}”",
        "other": "{{ count }} results for “{{ terms }}”"
      },
      "title": "Search our site",
      "placeholder": "Search",
      "submit": "Submit",
      "close": "Close search",
      "heading": {
        "one": "Search result",
        "other": "Search results"
      },
      "search_for": "Search for",
      "products": "Products",
      "loading": "Loading",
      "clear_search_term": "Clear search term",
      "number_of_results": "{{ result_number }} of {{ results_count }}",
      "number_of_results_found": "{{ results_count }} results found",
      "one_result_found": "1 result found"
    },
    "newsletter_form": {
      "newsletter_email": "Subscribe to our mailing list",
      "email_placeholder": "Email address",
      "confirmation": "Thanks for subscribing!",
      "submit": "Subscribe"
    },
    "filters": {
      "show_more": "Show More",
      "show_less": "Show Less"
    },
    "payment": {
      "method": "Payment methods"
    },
    "currency": {
      "dropdown_label": "Currency"
    },
    "language": {
      "dropdown_label": "Language"
    }
  },
  "sections": {
    "header": {
      "announcement_bar_label": "Announcement"
    },
    "slideshow": {
      "next_slide": "Next slide",
      "previous_slide": "Previous slide",
      "pause_slideshow": "Pause slideshow",
      "rotate_slideshow": "Play slideshow",
      "load_slide": "Load slide {{ slide_number }}",
      "navigation_instructions": "Use left/right arrows to navigate the slideshow or swipe left/right if using a mobile device"
    },
    "featured_product": {
      "title": "Featured product",
      "gallery_thumbnail_alt": "Load image into Gallery viewer, {{ imageAlt }}",
      "video_thumbnail_alt": "Load and play video in Gallery viewer, {{ imageAlt }}",
      "model_thumbnail_alt": "Load 3D model into Gallery viewer, {{ imageAlt }}"
    },
    "map": {
      "address_error": "Error looking up that address",
      "address_no_results": "No results for that address",
      "address_query_limit_html": "You have exceeded the Google API usage limit. Consider upgrading to a <a href=\"https://developers.google.com/maps/premium/usage-limits\">Premium Plan</a>.",
      "auth_error_html": "There was a problem authenticating your Google Maps account.",
      "section_heading": "Location"
    },
    "video": {
      "play": "Play {{ video_title }} video",
      "pause": "Pause {{ video_title }} video",
      "resume": "Resume {{ video_title }} video",
      "close": "Close {{ video_title }} video"
    }
  },
  "blogs": {
    "article": {
      "view_all": "View all",
      "view_all_blogs": "View all blogs",
      "all_topics": "All topics",
      "by_author": "by {{ author }}",
      "posted_in": "Posted in",
      "read_more": "Read more",
      "read_more_title": "Read more: {{ title }}",
      "back_to_blog": "Back to {{ title }}",
      "tags": "Tags",
      "article_with_count": {
        "one": "{{ count }} article",
        "other": "{{ count }} articles"
      }
    },
    "comments": {
      "title": "Leave a comment",
      "name": "Name",
      "email": "Email",
      "message": "Message",
      "post": "Post comment",
      "moderated": "Please note, comments must be approved before they are published",
      "success_moderated": "Your comment was posted successfully. We will publish it in a little while, as our blog is moderated.",
      "success": "Your comment was posted successfully! Thank you!",
      "unapproved": "The email address provided is not approved for posting comments.",
      "comments_with_count": {
        "one": "{{ count }} comment",
        "other": "{{ count }} comments"
      }
    }
  },
  "cart": {
    "general": {
      "title": "Your cart",
      "note": "Add a note to your order",
      "removed_item_html": "Removed <span class=\"cart__removed-product-details\">({{ quantity }}) {{ link }}</span> from your cart.",
      "remove": "Remove",
      "subtotal": "Subtotal",
      "savings": "You're saving",
      "taxes_and_shipping_at_checkout": "Taxes and shipping calculated at checkout",
      "taxes_and_shipping_policy_at_checkout_html": "Taxes and <a href=\"{{ link }}\">shipping</a> calculated at checkout",
      "taxes_included_but_shipping_at_checkout": "Tax included and shipping calculated at checkout",
      "taxes_included_and_shipping_policy_html": "Tax included. <a href=\"{{ link }}\">Shipping</a> calculated at checkout.",
      "update": "Update",
      "checkout": "Check out",
      "empty": "Your cart is currently empty.",
      "cookies_required": "Enable cookies to use the shopping cart",
      "continue_shopping": "Continue shopping",
      "cart_error": "There was an error while updating your cart. Please try again."
    },
    "label": {
      "discounted_total": "Discounted total",
      "product": "Product",
      "price": "Price",
      "price_column": "See Price column for discount details.",
      "product_details": "Product details",
      "quantity": "Quantity",
      "qty": "Qty",
      "regular_total": "Regular total",
      "remove": "Remove {{ product }}",
      "total": "Total",
      "update": "Update"
    },
    "popup": {
      "added_to_cart": "Just added to your cart",
      "cart_count": {
        "one": "{{ count }} item",
        "other": "{{ count }} items"
      },
      "product_details": "Product details",
      "quantity": "Qty",
      "quantity_label": "Quantity: {{ quantity_count }}"
    }
  },
  "collections": {
    "general": {
      "view_all": "View all",
      "view_all_label": "View all products in the {{ collection_name }} collection",
      "no_matches": "Sorry, there are no products in this collection",
      "items_with_count": {
        "one": "{{ count }} product",
        "other": "{{ count }} products"
      },
      "collection_label": "Collection"
    },
    "catalog": {
      "title": "Catalog"
    },
    "sorting": {
      "title": "Sort by"
    },
    "filters": {
      "title_tags": "Filter by",
      "all_tags": "All products"
    }
  },
  "contact": {
    "form": {
      "name": "Name",
      "email": "Email",
      "phone": "Phone Number",
      "message": "Message",
      "submit": "Send",
      "post_success": "Thanks for contacting us. We'll get back to you as soon as possible.",
      "error_heading": "Please adjust the following:"
    }
  },
  "customer": {
    "account": {
      "title": "My Account",
      "details": "Account Details",
      "view_addresses": "View Addresses",
      "return": "Return to Account Details"
    },
    "activate_account": {
      "title": "Activate Account",
      "subtext": "Create your password to activate your account.",
      "password": "Password",
      "password_confirm": "Confirm Password",
      "submit": "Activate Account",
      "cancel": "Decline Invitation"
    },
    "addresses": {
      "title": "Your Addresses",
      "default": "Default",
      "add_new": "Add a New Address",
      "edit_address": "Edit address",
      "first_name": "First Name",
      "last_name": "Last Name",
      "company": "Company",
      "address1": "Address",
      "address2": "Apartment, suite, etc.",
      "city": "City",
      "country": "Country/Region",
      "province": "Province",
      "zip": "Postal/Zip Code",
      "phone": "Phone",
      "set_default": "Set as default address",
      "add": "Add Address",
      "update": "Update Address",
      "cancel": "Cancel",
      "edit": "Edit",
      "delete": "Delete",
      "delete_confirm": "Are you sure you wish to delete this address?"
    },
    "login": {
      "title": "Login",
      "email": "Email",
      "password": "Password",
      "forgot_password": "Forgot your password?",
      "sign_in": "Sign In",
      "guest_title": "Continue as a guest",
      "guest_continue": "Continue"
    },
    "orders": {
      "title": "Order History",
      "order_number": "Order",
      "order_number_link": "Order number {{ number }}",
      "date": "Date",
      "payment_status": "Payment Status",
      "fulfillment_status": "Fulfillment Status",
      "total": "Total",
      "none": "You haven't placed any orders yet."
    },
    "order": {
      "title": "Order {{ name }}",
      "date_html": "Placed on {{ date }}",
      "cancelled_html": "Order Cancelled on {{ date }}",
      "cancelled_reason": "Reason: {{ reason }}",
      "billing_address": "Billing Address",
      "payment_status": "Payment Status",
      "shipping_address": "Shipping Address",
      "fulfillment_status": "Fulfillment Status",
      "discount": "Discount",
      "shipping": "Shipping",
      "tax": "Tax",
      "product": "Product",
      "sku": "SKU",
      "price": "Price",
      "quantity": "Quantity",
      "total": "Total",
      "fulfilled_at_html": "Fulfilled {{ date }}",
      "subtotal": "Subtotal",
      "track_shipment": "Track shipment"
    },
    "recover_password": {
      "title": "Reset your password",
      "email": "Email",
      "submit": "Submit",
      "cancel": "Cancel",
      "subtext": "We will send you an email to reset your password.",
      "success": "We've sent you an email with a link to update your password."
    },
    "reset_password": {
      "title": "Reset account password",
      "subtext": "Enter a new password for {{ email }}",
      "password": "Password",
      "password_confirm": "Confirm Password",
      "submit": "Reset Password"
    },
    "register": {
      "title": "Create Account",
      "first_name": "First Name",
      "last_name": "Last Name",
      "email": "Email",
      "password": "Password",
      "submit": "Create"
    }
  },
  "homepage": {
    "general": {
      "title": "Homepage"
    },
    "onboarding": {
      "product_title": "Your product's name",
      "product_description": "This area is used to describe your product’s details. Tell customers about the look, feel, and style of your product. Add details on color, materials used, sizing, and where it was made.",
      "collection_title": "Your collection's name",
      "blog_title": "Your post's title",
      "blog_excerpt": "Your store hasn’t published any blog posts yet. A blog can be used to talk about new product launches, tips, or other news you want to share with your customers. You can check out Shopify’s ecommerce blog for inspiration and advice for your own store and blog.",
      "blog_author": "Author name",
      "no_content": "This section doesn’t currently include any content. Add content to this section using the sidebar."
    }
  },
  "layout": {
    "navigation": {
      "search": "Search",
      "expand": "expand",
      "collapse": "collapse",
      "menu": "Menu"
    },
    "cart": {
      "title": "Cart",
      "items_count": {
        "one": "item",
        "other": "items"
      }
    },
    "customer": {
      "account": "Account",
      "log_out": "Log out",
      "log_in": "Log in",
      "create_account": "Create account"
    },
    "footer": {
      "social_platform": "{{ name }} on {{ platform }}"
    }
  },
  "products": {
    "product": {
      "login_to_purchase_title": "Login Required to Purchase",
      "login_to_purchase_text": "Please log in or create an account to add this item to your cart.",
      "regular_price": "Regular price",
      "sold_out": "Sold out",
      "unavailable": "Unavailable",
      "availability": "Availability",
      "on_sale": "Sale",
      "from_lowest_price_html": "from {{ lowest_price }}",
      "sale_price": "Sale price",
      "quantity": "Quantity",
      "add_to_cart": "Add to cart",
      "loader_label": "Adding product to your cart",
      "back_to_collection": "Back to {{ title }}",
      "vendor": "Vendor",
      "quantity_minimum_message": "Quantity must be 1 or more",
      "include_taxes": "Tax included.",
      "shipping_policy_html": "<a href=\"{{ link }}\">Shipping</a> calculated at checkout.",
      "unit_price_label": "Unit price",
      "view_cart": "View cart",
      "view_in_space": "View in your space",
      "view_in_space_label": "View in your space, loads item in augmented reality window"
    }
  },
  "store_availability": {
    "general": {
      "view_store_info": "View store information",
      "check_other_stores": "Check availability at other stores",
      "pick_up_available": "Pickup available",
      "pick_up_currently_unavailable": "Pickup currently unavailable",
      "pick_up_available_at_html": "Pickup available at <strong>{{ location_name }}</strong>",
      "pick_up_unavailable_at_html": "Pickup currently unavailable at <strong>{{ location_name }}</strong>"
    }
  },
  "gift_cards": {
    "issued": {
      "title_html": "Here's your {{ value }} gift card for {{ shop }}!",
      "subtext": "Your gift card",
      "gift_card_code": "Gift card code",
      "disabled": "Disabled",
      "expired": "Expired on {{ expiry }}",
      "active": "Expires on {{ expiry }}",
      "redeem_html": "Use this code at checkout to redeem your {{ value }} gift card",
      "shop_link": "Start shopping",
      "print": "Print this gift card",
      "remaining_html": "{{ balance }} left",
      "add_to_apple_wallet": "Add to Apple Wallet",
      "qr_image_alt": "QR code — scan to redeem gift card"
    }
  },
  "dynosim": {
    "auto": {
      "multiple_sessions_detected": "Multiple Sessions Detected",
      "your_account_is_active_in_another_window": "Your account is active in another window or device. Close the other session to continue using AlphaX Tuning Sim.",
      "alphax_tuning_simulator": "AlphaX Tuning Simulator",
      "garage_tuning": "Garage (Tuning)",
      "dynamometer": "Dynamometer",
      "drag_strip": "Drag Strip",
      "leaderboards": "Leaderboards",
      "login": "login",
      "import_tune": "IMPORT TUNE",
      "export_tune": "Export Tune",
      "start_engine": "START ENGINE",
      "rpm": "RPM",
      "147": "14.7",
      "afr": "AFR",
      "status": "Status:",
      "off": "OFF",
      "map": "MAP:",
      "101_kpa": "101 kPa",
      "boost": "Boost:",
      "00_psi": "0.0 psi",
      "config": "Config:",
      "twin_turbo": "TWIN TURBO",
      "tps": "TPS:",
      "0": "0%",
      "timing": "Timing:",
      "knk_retard": "KNK Retard:",
      "knock_count": "Knock Count:",
      "inj_pw_cyl_1": "Inj. PW (Cyl 1):",
      "00_ms": "0.0 ms",
      "vvt_intake": "VVT Intake:",
      "vvt_exhaust": "VVT Exhaust:",
      "coolant_temp": "Coolant Temp:",
      "_": "+ / - / *",
      "ethanol": "Ethanol:",
      "fuel_rail": "Fuel Rail:",
      "_psi": "-- PSI",
      "stft": "STFT:",
      "pump_load": "Pump Load:",
      "battery": "Battery:",
      "125_v": "12.5 V",
      "max_pedal_tps": "Max Pedal TPS",
      "100": "100%",
      "throttle_hold": "Throttle Hold",
      "pedal": "PEDAL",
      "ecu_flags": "ECU FLAGS:",
      "engine_limits": "Engine Limits",
      "trigger": "Trigger",
      "adv_uo": "Advanced users only!",
      "smart_alternator": "Smart Alternator",
      "axis_wizard": "Axis Wizard",
      "ve_table": "VE table",
      "target_afr_table": "Target AFR Table",
      "fuel_settings": "Fuel Settings",
      "flex_fuel": "Flex Fuel",
      "closed_loop_fuel": "Closed Loop Fuel",
      "accel_enrichment": "Accel Enrichment",
      "ignition_advance": "Ignition Advance",
      "ignition_settings": "Ignition Settings",
      "knock_control": "Knock Control",
      "vvt_intake_target": "VVT Intake Target",
      "vvt_exhaust_target": "VVT Exhaust Target",
      "vvt_vtec_settings": "VVT / VTEC Settings",
      "idle": "Idle",
      "cranking": "Cranking",
      "upgrades_mods": "Upgrades & Mods",
      "nitrous_system": "Nitrous System",
      "wastegate_duty_table": "Wastegate Duty Table",
      "cl_boost_target": "CL Boost Target",
      "launch_control": "Launch Control",
      "simulation_settings": "Simulation Settings",
      "simple": "SIMPLE",
      "adv": "ADV",
      "buy_advanced_mode": "Buy Advanced Mode!",
      "log_off": "LOG OFF",
      "selection_tools": "Selection Tools:",
      "interp_x_row": "Interp X (Row)",
      "interp_y_col": "Interp Y (Col)",
      "interp_2d_area": "Interp 2D (Area)",
      "keys_hinterp_x_vinterp_y_iinterp_2d_gtlt": "Keys: H=Interp X · V=Interp Y · I=Interp 2D · &gt;/&lt;=±1 · +/-/*=math then Enter · Arrows=navigate · Ctrl+C/V=copy/paste · Ctrl+Z/Y=undo/redo",
      "ve_table_load_vs_rpm": "VE Table (Load vs RPM)",
      "higher_numbers_more_fuel_adjust_to_hit_t": "Higher numbers = more fuel. Adjust to hit target AFR.",
      "target_afr_table_load_vs_rpm": "Target AFR Table (Load vs RPM)",
      "commanded_airfuel_ratio_core_part_of_the": "Commanded Air/Fuel Ratio. Core part of the Speed Density equation.",
      "fuel_injector_settings": "Fuel & Injector Settings",
      "injector_size_ccmin": "Injector Size (cc/min)",
      "injector_reference_pressure_kpa": "Injector Reference Pressure (kPa)",
      "dead_time_ms_by_v": "Dead Time (ms by V)",
      "c": "°C",
      "multiplier_at_each_iat_10_no_change_09_1": "Multiplier at each IAT. 1.0 = no change, 0.9 = −10%, 1.1 = +10%.",
      "ect_fuel_enrichment_": "ECT Fuel Enrichment (×)",
      "fuel_multiplier_on_cold_start_10_no_corr": "Fuel multiplier on cold start. 1.0 = no correction at operating temp.",
      "fuel_octane": "Fuel Octane",
      "87_aki_regular": "87 AKI (Regular)",
      "91_aki_premium": "91 AKI (Premium)",
      "93_aki_premium": "93 AKI (Premium+)",
      "100_aki_race_gas": "100 AKI (Race Gas)",
      "104_aki_race_gas": "104 AKI (Race Gas)",
      "116_aki_methanolrace": "116+ AKI (Methanol/Race)",
      "display_afr_as_lambda_3_decimals": "Display AFR as Lambda (3 decimals)",
      "enable_fuel_pressure_model": "Enable Fuel Pressure Model",
      "base_fuel_pressure_psi": "Base Fuel Pressure (PSI)",
      "fuel_system_type": "Fuel System Type",
      "return_style_rising_rate": "Return Style (rising rate)",
      "returnless_fixed_pressure": "Returnless (fixed pressure)",
      "return_style_rail_rises_11_with_boost_in": "Return style: rail rises 1:1 with boost — injector differential stays constant. Returnless: fixed rail pressure, injector flow drops under boost.",
      "apply_settings": "Apply Settings",
      "ignition_timing_table_load_vs_rpm": "Ignition Timing Table (Load vs RPM)",
      "degrees_before_top_dead_center_too_much_": "Degrees Before Top Dead Center. Too much advance causes knock.",
      "flex_fuel_sensor_simulation": "Flex Fuel Sensor Simulation",
      "moving_this_slider_simulates_adding_etha": "Moving this slider simulates adding ethanol to the fuel tank. The ECU will automatically adjust the base fuel mass requirement to maintain your commanded AFR (stoich scaling). You must use the compensation tables below to unlock the performance benefits (timing/boost) and final VE tweaks.",
      "enable_flex_fuel_tuning_populate_flex_ta": "Enable Flex Fuel Tuning (Populate Flex Tables on Perfect Export)",
      "ethanol_content_": "Ethanol Content (%)",
      "apply_content": "Apply Content",
      "flex_fuel_ve_adder_": "Flex Fuel VE Adder (%)",
      "blend_curve_0_100_x_base_map_map_vs_rpm": "Blend Curve (0-100%) x Base Map (MAP vs RPM)",
      "flex_fuel_afr_offset": "Flex Fuel AFR Offset",
      "flex_fuel_timing_adder_deg": "Flex Fuel Timing Adder (deg)",
      "flex_fuel_boost_duty_adder_": "Flex Fuel Boost Duty Adder (%)",
      "blend_curve_0_100_x_base_map_tps_vs_rpm": "Blend Curve (0-100%) x Base Map (TPS vs RPM)",
      "closed_loop_fuel_stft": "Closed-Loop Fuel (STFT)",
      "enable_closed_loop_correction": "Enable Closed-Loop Correction",
      "deadband_": "Deadband (%)",
      "lambda_error_within_this_band_is_ignored": "Lambda error within this band is ignored. 2% = no correction if actual AFR is within ±2% of target.",
      "tps_lt_5_rpm_near_idle_target": "(TPS &lt; 5%, RPM near idle target)",
      "time_constant_s": "Time Constant (s)",
      "gain_00833_s": "Gain: 0.0833 /s",
      "min_correction_": "Min Correction (%)",
      "max_correction_": "Max Correction (%)",
      "part_throttle_cruise": "(part throttle / cruise)",
      "gain_01250_s": "Gain: 0.1250 /s",
      "tps_gt_90": "(TPS &gt; 90%)",
      "gain_02000_s": "Gain: 0.2000 /s",
      "acceleration_enrichment": "Acceleration Enrichment",
      "corrects_fueling_during_rapid_throttle_o": "Corrects fueling during rapid throttle openings. MAP lag is simulated when any mode is active (0.3s delay at idle, fading to instant above 2000 RPM).",
      "mode": "MODE:",
      "none_disabled": "None (Disabled)",
      "ms_adder": "MS Adder",
      "map_prediction": "MAP Prediction",
      "accel_time_s": "Accel Time (s)",
      "hard_cutoff_duration_of_enrichment_event": "Hard cutoff duration of enrichment event",
      "decay_rate": "Decay Rate",
      "ms_mode_mss_middot_map_mode_blends": "MS mode: ms/s &middot; MAP mode: blend/s",
      "ms_adder_dtps_s_vs_rpm_rarr_ms": "MS Adder (dTPS %/s vs RPM &rarr; ms)",
      "extra_injection_ms_on_tip_in_y_tps_rate_": "Extra injection ms on tip-in. Y = TPS rate of change (%/s), X = RPM.",
      "map_prediction_tps_vs_rpm_rarr_kpa": "MAP Prediction (TPS % vs RPM &rarr; kPa)",
      "predicted_map_for_veafrtiming_lookups_du": "Predicted MAP for VE/AFR/timing lookups during tip-in. Y = TPS %, X = RPM.",
      "ignition_system_mode": "Ignition System Mode",
      "sets_coil_topology_recharge_time_and_mel": "Sets coil topology, recharge time, and melt behavior.",
      "distributor_single_coil": "Distributor (Single Coil)",
      "wasted_spark_n2_coils": "Wasted Spark (N/2 Coils)",
      "fully_sequential_cop": "Fully Sequential / COP",
      "spark_plug_gap_inches": "Spark Plug Gap (inches)",
      "wider_gap_needs_more_dwell_to_fire_under": "Wider gap = needs more dwell to fire. Under boost, effective gap shrinks 0.005&quot; per 10 psi — tighter gaps recommended on boosted builds.",
      "degrees_of_retard_at_each_iat_0_no_retar": "Degrees of retard at each IAT. 0 = no retard.",
      "coil_dwell_time_ms_by_battery_v": "Coil Dwell Time (ms by Battery V)",
      "coil_charge_time_low_voltage_during_cran": "Coil charge time. Low voltage during cranking may cause weak spark.",
      "knock_sensor_spectrogram": "Knock Sensor Spectrogram",
      "pause": "PAUSE",
      "cyan_noise_level_nbspnbsp_red_dashed_thr": "Cyan = noise level &nbsp;|&nbsp; Red dashed = threshold at current RPM",
      "_25s": "-2.5s",
      "now": "Now",
      "knock_threshold_db_vs_rpm": "Knock Threshold (dB vs RPM)",
      "noise_level_above_which_a_knock_event_tr": "Noise level above which a knock event triggers retard. At idle background noise is ~-26 dB; knock spikes to ~-2 dB.\n                                Set each cell just below the lowest knock spike at that RPM. Default -10 dB is a good starting point at lower RPM.\n                                At high RPM you may need to lower to -15 dB or below to avoid false positives.",
      "control_parameters": "Control Parameters",
      "enable_knock_control": "Enable Knock Control",
      "complete_knock_frequency_calibration_bel": "Complete Knock Frequency Calibration below to unlock.",
      "attack_degevent": "Attack (deg/event)",
      "degrees_removed_per_knock_detection_0510": "Degrees removed per knock detection. 0.5–10°",
      "max_retard_deg": "Max Retard (deg)",
      "maximum_accumulated_retard_120": "Maximum accumulated retard. 1–20°",
      "recovery_rate_degrev": "Recovery Rate (deg/rev)",
      "degrees_recovered_per_engine_revolution_": "Degrees recovered per engine revolution. 0.1–2.0",
      "min_tps_to_engage_": "Min TPS to Engage (%)",
      "suppresses_retard_below_this_throttle_po": "Suppresses retard below this throttle position. Prevents false triggers on decel pops.",
      "min_map_to_engage_kpa": "Min MAP to Engage (kPa)",
      "suppresses_retard_below_this_manifold_pr": "Suppresses retard below this manifold pressure. 60 kPa ≈ light cruise.",
      "knock_control_frequency_calibration_mode": "Knock Control Frequency Calibration Mode",
      "enter_calibration_mode": "Enter Calibration Mode",
      "identify_the_engines_natural_knock_reson": "Identify the engine's natural knock resonant frequency using the 3D spectrogram below. Start the engine and\n                                induce knock (over-advance timing or exceed octane limit). A bright streak will appear at a specific frequency\n                                on the waterfall — that is the engine's resonance point. Align the center frequency marker to that streak,\n                                then confirm calibration to unlock Knock Control.",
      "formula_f_573_boremm_nbspnbsp_81_mm_bore": "Formula: f ≈ 573 ÷ bore_mm &nbsp;|&nbsp; 81 mm bore ≈ 7.07 kHz &nbsp;|&nbsp; 102 mm bore ≈ 5.61 kHz",
      "20k": "20k",
      "15k": "15k",
      "10k": "10k",
      "5k": "5k",
      "_5_seconds_ago": "← 5 seconds ago",
      "now_": "Now →",
      "center_freq_khz": "Center Freq (kHz)",
      "khz": "kHz",
      "temp_timing_adder": "Temp Timing Adder",
      "_for": "° for",
      "s": "s",
      "apply": "Apply",
      "confirm_calibration": "Confirm Calibration",
      "recalibrate": "Recalibrate",
      "nitrous_oxide_system": "Nitrous Oxide System",
      "upgrades_amp_mods": "Upgrades &amp; Mods",
      "n2o_jet_size_thousandths_in": "N2O Jet Size (thousandths in.)",
      "estimated_power": "Estimated Power",
      "_337_hp": "≈ 33.7 HP",
      "fuel_jet_size_thousandths_in": "Fuel Jet Size (thousandths in.)",
      "wet_shot_fuel_solenoid_handles_base_enri": "Wet shot: fuel solenoid handles base enrichment. ECU VE comp adds on top.",
      "activation_mode": "Activation Mode",
      "button_switch": "Button / Switch",
      "ecu_control": "ECU Control",
      "ecu_control_parameters": "ECU Control Parameters",
      "min_tps_": "Min TPS (%)",
      "min_rpm": "Min RPM",
      "max_rpm": "Max RPM",
      "max_map_kpa": "Max MAP (kPa)",
      "afr_safety_cut_lean": "AFR Safety Cut (lean)",
      "fuel_ve_comp_": "Fuel VE Comp. (%)",
      "extra_fuel_when_n2o_is_active_dry_primar": "Extra fuel when N2O is active. Dry = primary comp. Wet = supplement on top of fuel solenoid.",
      "timing_retard_": "Timing Retard (°)",
      "degrees_pulled_from_commanded_timing_whe": "Degrees pulled from commanded timing when N2O is active.",
      "apply_nitrous_settings": "Apply Nitrous Settings",
      "vvt_intake_advance_target_load_vs_rpm": "VVT Intake Advance Target (Load vs RPM)",
      "positive_degrees_of_intake_cam_advance_i": "Positive degrees of intake cam advance. Interpolates absolute \"In_X\" engine maps.",
      "vvt_exhaust_retard_target_load_vs_rpm": "VVT Exhaust Retard Target (Load vs RPM)",
      "negative_degrees_of_exhaust_cam_retard_i": "Negative degrees of exhaust cam retard. Interpolates absolute \"Ex_X\" engine maps.",
      "variable_valve_lift_vvl_vtec": "Variable Valve Lift (VVL / VTEC)",
      "vvl_high_cam_switch_rpm": "VVL / High Cam Switch (RPM)",
      "vvl_high_cam_min_tps_": "VVL / High Cam Min TPS (%)",
      "vvl_fuel_adder_ve_": "VVL Fuel Adder (VE %)",
      "vvl_timing_adder_": "VVL Timing Adder (°)",
      "continuous_vvt_phase_angles_are_controll": "Continuous VVT phase angles are controlled via the 9x9 tables.",
      "closed_loop_pid_control": "Closed Loop PID Control",
      "enable_closed_loop_pid_control": "Enable Closed Loop PID Control",
      "proportional_kp": "Proportional (Kp)",
      "integral_ki": "Integral (Ki)",
      "derivative_kd": "Derivative (Kd)",
      "higher_kp_faster_response_ki_eliminates_": "Higher Kp = faster response. Ki eliminates steady-state error. Kd damps overshoot. Live display shows actual° / target° when enabled.",
      "wastegate_duty_table_tps_vs_rpm": "Wastegate Duty Table (TPS vs RPM)",
      "commanded_wastegate_solenoid_duty_cycle_": "Commanded wastegate solenoid duty cycle (0–100%). Higher duty = more boost. Requires a turbocharger mod installed. In Closed-Loop Boost mode this table acts as the feed-forward base; the PID trims on top.",
      "cl_boost_target_table_tps_vs_rpm": "CL Boost Target Table (TPS vs RPM)",
      "target_boost_pressure_in_psi_used_when_c": "Target boost pressure in PSI. Used when Closed-Loop Boost is enabled in Mod Settings. 0 = match wastegate spring pressure. The WG Duty table is the feed-forward base; the PID adjusts duty to hit this target.",
      "rev_limit_rpm": "Rev Limit (RPM)",
      "rev_limit_hysteresis_rpm": "Rev Limit Hysteresis (RPM)",
      "fuel_cut": "Fuel Cut",
      "spark_cut": "Spark Cut",
      "enable_decel_fuel_cut": "Enable Decel Fuel Cut",
      "cut_delay_sec": "Cut Delay (Sec)",
      "boost_protection": "Boost Protection",
      "boost_cut_psi": "Boost Cut (psi)",
      "hysteresis_psi": "Hysteresis (psi)",
      "trigger_calibration": "Trigger Calibration",
      "timing_light_mode": "Timing Light Mode",
      "simulates_a_timing_light_check_engine_st": "Simulates a timing light check. Engine start is disabled while active.",
      "must_match_engine_base_offset_affects_ti": "must match engine base offset — affects timing at all times",
      "fixed_timing_ecu_commanded_045_btdc": "Fixed Timing — ECU commanded (0–45° BTDC)",
      "enable_smart_alternator": "Enable Smart Alternator",
      "alt_pressure_rises_05_v_per_1000_rpm_pid": "Alt pressure rises +0.5 V per 1000 RPM. PID controls duty to hold target voltage.",
      "p_gain": "P Gain",
      "i_gain": "I Gain",
      "d_gain": "D Gain",
      "alternator_duty": "Alternator Duty:",
      "na": "N/A",
      "axis_setup_wizard": "Axis Setup Wizard",
      "sets_the_16_point_rpm_and_map_load_axes_": "Sets the 16-point RPM and MAP (load) axes for the VE, AFR, and Timing tables. WG Duty table columns (RPM) also update. The WG Duty row axis (TPS) is unaffected.",
      "base_rpm": "Base RPM",
      "base_kpa_min_load": "Base kPa (min load)",
      "max_kpa": "Max kPa",
      "apply_axis_wizard": "Apply Axis Wizard",
      "reset_to_default": "Reset to Default",
      "note_existing_tune_values_are_interpolat": "Note: existing tune values are interpolated/extrapolated onto the new axes. Values beyond your current range are linearly extrapolated from the edge trend.",
      "idle_settings": "Idle Settings",
      "maximum_idle_tps": "Maximum Idle TPS%",
      "actual_throttle_when_duty_curve_reads_10": "Actual throttle % when duty curve reads 100%.",
      "idle_control_rpm_upper_limit": "Idle Control RPM Upper Limit",
      "idle_control_disengages_above_target_rpm": "Idle control disengages above Target RPM + this value.",
      "target_idle_rpm_vs_coolant_temp": "Target Idle RPM vs Coolant Temp",
      "idle_rpm_target_by_coolant_temperature_r": "Idle RPM target by coolant temperature. Runs higher when cold.",
      "idle_duty_vs_coolant_temp_": "Idle Duty vs Coolant Temp (%)",
      "_of_maximum_idle_tps_to_command_at_each_": "% of Maximum Idle TPS% to command at each coolant temperature.",
      "closed_loop_idle_ignition": "Closed Loop Idle Ignition",
      "uses_ignition_timing_to_maintain_target_": "Uses ignition timing to maintain target idle RPM for faster corrections.",
      "p": "P",
      "i": "I",
      "d": "D",
      "cranking_starting": "Cranking / Starting",
      "base_ve": "Base VE",
      "max_crank_rpm": "Max Crank RPM",
      "decay_s": "Decay (s)",
      "crank_time_s": "Crank Time (s)",
      "cranking_idle_air_duty_vs_coolant_temp_": "Cranking Idle Air Duty vs Coolant Temp (%)",
      "throttle_position_air_during_cranking_hi": "Throttle position (air) during cranking. Higher when cold to overcome friction.",
      "post_crank_enrichment_vs_coolant_temp_ve": "Post-Crank Enrichment vs Coolant Temp (×VE)",
      "fuel_multiplier_applied_immediately_afte": "Fuel multiplier applied immediately after cranking ends. 1.0 = no enrichment.",
      "post_crank_decay_cycles": "Post-Crank Decay Cycles",
      "engine_cycles_720_each_for_enrichment_to": "Engine cycles (720° each) for enrichment to decay from curve value to 1.0×.",
      "vehicle_upgrades": "Vehicle Upgrades",
      "export_mod_list": "EXPORT MOD LIST",
      "import_mod_list": "IMPORT MOD LIST",
      "mod_collection": "Mod Collection",
      "tuner_warning_extreme_mods_like_heavy_ca": "TUNER WARNING: Extreme mods like heavy cams will increase idle vacuum penalty (raises base MAP), which can stall your engine! You will need to tune your low-RPM fuel/timing and raise target idle RPM to compensate.",
      "launch_control_two_step": "Launch Control / Two-Step",
      "enable_launch_control": "Enable Launch Control",
      "launch_rpm": "Launch RPM",
      "hysteresis_rpm": "Hysteresis (RPM)",
      "window_size_rpm": "Window Size (RPM)",
      "cut_type": "Cut Type",
      "ignition_cut": "Ignition Cut",
      "both_hard_cut": "Both (Hard Cut)",
      "window_start_timing_deg": "Window Start Timing (deg)",
      "limit_timing_deg_absolute": "Limit Timing (deg absolute)",
      "fuel_adder_afr_": "Fuel Adder (AFR %)",
      "activate_two_step_mode_switch": "Activate Two-Step Mode Switch",
      "test_your_launch_settings_in_the_garage_": "Test your launch settings in the garage. When active, the engine will limit to Launch RPM at full throttle even in Neutral.",
      "ambient_conditions_used_as_the_baseline_": "Ambient conditions used as the baseline for all simulations — dyno pulls, drag runs, and the garage physics loop.",
      "unit_system": "Unit System",
      "affects_all_displayed_temperatures_press": "Affects all displayed temperatures, pressures, and speed. AFR/Lambda can be toggled separately by clicking the gauge.",
      "pressure_display_mode": "Pressure Display Mode",
      "absolute": "Absolute",
      "gauge": "Gauge",
      "switches_pressure_on_y_axes_and_gauges": "Switches pressure on Y-axes and gauges between absolute and gauge pressure. Internal math always uses absolute kPa.",
      "ambient_temperature_f": "Ambient Temperature (°F)",
      "ambient_temperature_c": "Ambient Temperature (°C)",
      "sets_base_iat_for_the_physics_loop": "Sets base IAT for the physics loop.",
      "barometric_pressure_kpa": "Barometric Pressure (kPa)",
      "affects_map_ceiling_and_airmass_scaling_": "Affects MAP ceiling and airmass scaling (altitude).",
      "relative_humidity_": "Relative Humidity (%)",
      "used_for_dyno_correction_factor_sae_std": "Used for dyno correction factor (SAE / STD).",
      "coolant_temperature_simulation": "Coolant Temperature Simulation",
      "enable_ect_simulation": "Enable ECT Simulation",
      "when_enabled_engine_starts_cold_at_ambie": "When enabled, engine starts cold at ambient temp and warms to 90°C. Disabled = ECT locked at 90°C.",
      "o2_sensor_simulation": "O2 Sensor Simulation",
      "enable_o2_transport_delay_amp_combustion": "Enable O2 Transport Delay &amp; Combustion Noise",
      "adds_exhaust_transport_delay_to_afr_disp": "Adds exhaust transport delay to AFR display (300ms at idle, 0ms at 3500 RPM) and ±3% combustion variance to physics at low RPM.",
      "starter_mode": "Starter Mode",
      "hold_to_engage_hold_the_button_while_the": "Hold to Engage: hold the button while the starter cranks; release after engine fires.",
      "knock_indicator": "Knock Indicator",
      "show_knock_event_indicator_overlay": "Show knock event indicator overlay",
      "floating_counter_shown_in_all_views_when": "Floating counter shown in all views when the engine is knocking. In Advanced Mode use the Knock Control tab instead.",
      "transmission_selection": "Transmission Selection",
      "export": "EXPORT",
      "custom_ratios": "Custom Ratios",
      "final_drive_ratio": "FINAL DRIVE RATIO",
      "gear_1": "GEAR 1",
      "gear_2": "GEAR 2",
      "gear_3": "GEAR 3",
      "gear_4": "GEAR 4",
      "gear_5": "GEAR 5",
      "gear_6": "GEAR 6",
      "gear_7": "GEAR 7",
      "gear_8": "GEAR 8",
      "gear_9": "GEAR 9",
      "gear_10": "GEAR 10",
      "set_ratio_to_0_to_disable_a_gear": "Set ratio to 0 to disable a gear.",
      "apply_simulation_settings": "Apply Simulation Settings",
      "virtual_dynamometer": "Virtual Dynamometer",
      "loads_the_engine_dynamically_to_perform_": "Loads the engine dynamically to perform a real-time full-throttle sweep from start RPM to redline.",
      "auto_log_off": "AUTO-LOG OFF",
      "set_as_reference": "SET AS REFERENCE",
      "hold_n2o": "HOLD — N2O",
      "smoothing": "SMOOTHING:",
      "0_raw": "0 (Raw)",
      "5_max": "5 (Max)",
      "correction": "CORRECTION:",
      "none": "None",
      "sae": "SAE",
      "std": "STD",
      "load_dyno": "Load Dyno",
      "rpm_lock": "RPM Lock",
      "dynojet": "Dynojet",
      "rpms": "RPM/S:",
      "target_rpm": "TARGET RPM:",
      "afr_guideline": "AFR GUIDELINE:",
      "start_rpm": "START RPM:",
      "ambient_conditions_advanced_simulation_s": "Ambient conditions: Advanced → Simulation Settings",
      "leaderboard_display_name": "Leaderboard Display Name",
      "submit_to_leaderboard": "Submit to Leaderboard",
      "clutch_0": "CLUTCH: 0%",
      "run": "RUN",
      "launch": "LAUNCH",
      "60ft": "60ft",
      "330ft": "330ft",
      "18_mile": "1/8 Mile",
      "1000ft": "1000ft",
      "14_mile": "1/4 Mile",
      "reaction_time": "Reaction Time",
      "9872_check_run_category": "&#9872; Check Run Category",
      "sim_config": "Sim Config",
      "weight_lbs": "Weight (lbs)",
      "shift_rpm": "Shift RPM",
      "shift_delay_s": "Shift Delay (s)",
      "tires": "Tires",
      "economy": "Economy",
      "street": "Street",
      "summer": "Summer",
      "drag_radials": "Drag Radials",
      "drag_slicks": "Drag Slicks",
      "clutch_slip_s": "Clutch Slip (s)",
      "lb_class": "LB Class",
      "run_controls": "Run Controls",
      "start_1x": "START (1x)",
      "ff_3x": "FF (3x)",
      "instant": "INSTANT",
      "shift_up": "SHIFT UP",
      "abort": "ABORT",
      "n2o": "N2O",
      "manual_mode": "Manual Mode",
      "no_shift_on_slip": "No Shift on Slip",
      "auto_log": "Auto-Log",
      "hold_cspace_on_line_release_c_to_launch_": "Hold C+SPACE on line → release C to launch &nbsp;|&nbsp; SPACE=throttle &nbsp;C=clutch &nbsp;S=shift↑ &nbsp;X=shift↓",
      "requirement": "Requirement:",
      "logged_in": "logged in",
      "advanced_mode": "Advanced Mode",
      "default_vehicle_weight": "Default Vehicle Weight",
      "01s_shift_delay": "0.1s Shift Delay",
      "engine": "Engine",
      "category": "Category",
      "stock_economy": "Stock — Economy",
      "stock_street": "Stock — Street",
      "stock_summer": "Stock — Summer",
      "stock_drag_radials": "Stock — Drag Radials",
      "stock_drag_slicks": "Stock — Drag Slicks",
      "mod_na_economy": "Mod N/A — Economy",
      "mod_na_street": "Mod N/A — Street",
      "mod_na_summer": "Mod N/A — Summer",
      "mod_na_drag_radials": "Mod N/A — Drag Radials",
      "mod_na_drag_slicks": "Mod N/A — Drag Slicks",
      "power_adder_economy": "Power Adder — Economy",
      "power_adder_street": "Power Adder — Street",
      "power_adder_summer": "Power Adder — Summer",
      "power_adder_drag_radials": "Power Adder — Drag Radials",
      "power_adder_drag_slicks": "Power Adder — Drag Slicks",
      "super_pa_economy": "Super PA — Economy",
      "super_pa_street": "Super PA — Street",
      "super_pa_summer": "Super PA — Summer",
      "super_pa_drag_radials": "Super PA — Drag Radials",
      "super_pa_drag_slicks": "Super PA — Drag Slicks",
      "search": "Search",
      "knock_detected": "Knock Detected",
      "0_events": "0 events",
      "v001": "v0.0.1",
      "1_2": "1 / 2",
      "times": "&times;",
      "simple_mode_vs_advanced_mode": "Simple Mode vs Advanced Mode",
      "free": "(Free)",
      "purchased": "(Purchased)",
      "click_here_to_get_advanced_mode_": "Click Here to get Advanced Mode →",
      "extra_engines_amp_mods": "Extra Engines &amp; Mods",
      "click_here_to_browse_engines_": "Click Here to browse Engines →",
      "click_here_to_browse_mods_": "Click Here to browse Mods →",
      "128274_log_in_to_access_your_purchases": "&#128274; Log In to Access Your Purchases",
      "alphax_account": "AlphaX account",
      "alphaxprcom": "alphaxpr.com",
      "controls": "Controls",
      "space": "Space",
      "click_drag": "Click / Drag",
      "click_cell": "Click cell",
      "ctrlz_y": "Ctrl+Z / Y",
      "table_keyboard_shortcuts": "Table Keyboard Shortcuts",
      "arrows": "Arrows",
      "gt_lt": "&gt; / &lt;",
      "h": "H",
      "v": "V",
      "ctrlc_v": "Ctrl+C / V",
      "datalogging": "Datalogging",
      "basic_tuning_tips": "Basic Tuning Tips",
      "ignition_timing": "Ignition Timing",
      "target_afr": "Target AFR",
      "map_axis": "MAP axis",
      "_back": "← Back",
      "controls_": "Controls →",
      "got_it_": "Got it! ✓",
      "run_category_check": "Run Category Check",
      "close": "Close",
      "save_your_tune": "Save Your Tune",
      "you_have_unsaved_tuning_changes": "You have unsaved tuning changes.",
      "export_your_tune_before_closing_so_you_c": "Export your tune before closing so you can reload it later.",
      "dismiss": "Dismiss",
      "keep_adjusting": "Keep Adjusting",
      "timing_is_correct_": "Timing is Correct ✓",
      "commanded_wastegate_solenoid_duty_cycle": "Commanded wastegate solenoid duty cycle (0–100%). Higher duty = more boost. Requires a turbocharger mod installed. In Closed-Loop Boost mode this table acts as the feed-forward base; the PID trims on top.",
      "integrates_the_lambda_error_between_actu": "Integrates the lambda error between actual and target AFR each frame and applies a Short-Term Fuel Trim multiplier to correct fueling. Uses your Target AFR table as the setpoint. The integrator gain is",
      "dry_shot_switch_mode_no_ecu_compensation": "Dry shot, switch mode: no ECU compensation is applied. Bake your fuel and timing corrections directly into your VE and timing maps.",
      "sets_the_16_point_rpm_and_map_load_axes": "Sets the 16-point RPM and MAP (load) axes for the VE, AFR, and Timing tables. WG Duty table columns (RPM) also update. The WG Duty row axis (TPS) is unaffected.",
      "keys_hinterp_x_vinterp_y_iinterp_2d_1_ma": "Keys: H=Interp X · V=Interp Y · I=Interp 2D · &gt;/&lt;=±1 · +/-/*=math then Enter · Arrows=navigate · Ctrl+C/V=copy/paste · Ctrl+Z/Y=undo/redo",
      "higher_kp_faster_response_ki_eliminates": "Higher Kp = faster response. Ki eliminates steady-state error. Kd damps overshoot. Live display shows actual° / target° when enabled.",
      "formula_f_573_boremm_81_mm_bore_707_khz": "Formula: f ≈ 573 ÷ bore_mm &nbsp;|&nbsp; 81 mm bore ≈ 7.07 kHz &nbsp;|&nbsp; 102 mm bore ≈ 5.61 kHz",
      "test_your_launch_settings_in_the_garage": "Test your launch settings in the garage. When active, the engine will limit to Launch RPM at full throttle even in Neutral.",
      "hold_cspace_on_line_release_c_to_launch": "Hold C+SPACE on line → release C to launch &nbsp;|&nbsp; SPACE=throttle &nbsp;C=clutch &nbsp;S=shift↑ &nbsp;X=shift↓",
      "ambient_conditions_used_as_the_baseline": "Ambient conditions used as the baseline for all simulations — dyno pulls, drag runs, and the garage physics loop.",
      "mods_include_turbochargers_camshafts_coo": "Mods include turbochargers, camshafts, cooling upgrades, and more — each with real physics effects.",
      "loads_the_engine_dynamically_to_perform": "Loads the engine dynamically to perform a real-time full-throttle sweep from start RPM to redline.",
      "each_engine_has_its_own_power_curve_knoc": "Each engine has its own power curve, knock limits, compression ratio, and tuning maps.",
      "trigger_angle_offset_ecu_360360": "Trigger Angle Offset — ECU (-360–360°)",
      "55_sub_axes_derived_from_the_main_rpm_an": "5×5 sub-axes derived from the main RPM and MAP axes. Scales with the Axis Wizard.",
      "advanced_mode_activates_automatically_wh": "Advanced Mode activates automatically when your purchase is detected at login.",
      "trigger_offset_matches_engine_base_the_t": "Trigger offset matches engine base — the timing mark is perfectly aligned.",
      "inj_mismatch": "Injector size mismatch — check Fuel Settings matches installed injectors",
      "uses_ignition_timing_to_maintain_target": "Uses ignition timing to maintain target idle RPM for faster corrections.",
      "on_the_store_for_the_simulator_to_detect": "on the store for the simulator to detect your purchases and unlock them.",
      "engine_load_in_kpa_higher_more_load_mor": "— engine load in kPa. Higher = more load = more fuel &amp; timing needed",
      "if_you_purchased_something_and_dont_see": "If you purchased something and don't see it, log in to your account on",
      "cyan_noise_level_red_dashed_threshold_at": "Cyan = noise level &nbsp;|&nbsp; Red dashed = threshold at current RPM",
      "torque_bonus_0_at_145_v_3_at_125_v_reduc": "Torque bonus: 0% at 14.5 V → +3% at 12.5 V (reduced alternator drag).",
      "extra_injection_ms_on_tip_in_y_tps_rate": "Extra injection ms on tip-in. Y = TPS rate of change (%/s), X = RPM.",
      "your_purchased_engines_mods_and_advanced": "Your purchased engines, mods, and Advanced Mode are tied to your",
      "logs_include_rpm_map_afr_timing_ve_torqu": "Logs include RPM, MAP, AFR, timing, VE, torque, boost, and more",
      "advance_for_power_but_watch_for_knock_t": "— advance for power, but watch for knock. Typical MBT is 25–35°",
      "degrees_before_top_dead_center_too_much": "Degrees Before Top Dead Center. Too much advance causes knock.",
      "of_maximum_idle_tps_to_command_at_each": "% of Maximum Idle TPS% to command at each coolant temperature.",
      "richer_11121_under_boostwot_stoich_1471": "— richer (11–12:1) under boost/WOT, stoich (14.7:1) at cruise",
      "controls_fuel_delivery_aim_for_1471_afr": "— controls fuel delivery. Aim for ~14.7:1 AFR at cruise",
      "to_submit_runs_must_use": "to submit. \n                            Runs must use",
      "flood_hint": "Hold throttle to floor while cranking to clear flood",
      "affects_map_ceiling_and_airmass_scaling": "Affects MAP ceiling and airmass scaling (altitude).",
      "select_an_engine_and_category_to_view_le": "Select an engine and category to view leaderboards.",
      "degrees_recovered_per_engine_revolution": "Degrees recovered per engine revolution. 0.1–2.0",
      "enable_o2_transport_delay_combustion_noi": "Enable O2 Transport Delay &amp; Combustion Noise",
      "focus_math_input_type_value_enter_to_ap": "— Focus math input → type value → Enter to apply",
      "start_dyno_pull": "START DYNO PULL",
      "drag_strip_leaderboards": "Drag Strip Leaderboards",
      "copy_paste_selection_as_spreadsheet_dat": "— Copy / paste selection as spreadsheet data",
      "to_start_recording_stops_and_exports_a_c": "to start recording — stops and exports a CSV",
      "10003_ve_timing_target_afr_tables": "&#10003; VE, Timing &amp; Target AFR tables",
      "10003_flex_fuel_tables_e85_physics": "&#10003; Flex Fuel tables &amp; E85 physics",
      "interpolate_horizontally_across_selecti": "— Interpolate horizontally across selection",
      "cranking_idle_air_duty_vs_coolant_temp": "Cranking Idle Air Duty vs Coolant Temp (%)",
      "interpolate_vertically_across_selection": "— Interpolate vertically across selection",
      "available_in_garage_dyno_and_drag_modes": "Available in Garage, Dyno, and Drag modes",
      "ms_mode_mss_map_mode_blends": "MS mode: ms/s &middot; MAP mode: blend/s",
      "map_prediction_tps_vs_rpm_kpa": "MAP Prediction (TPS % vs RPM &rarr; kPa)",
      "10003_engine_damage_failure_rng": "&#10003; Engine damage &amp; failure RNG",
      "timing_is_correct": "Timing is Correct ✓",
      "imperial_f_psi_mph": "Imperial (°F &middot; PSI &middot; MPH)",
      "move_selection_hold_shift_to_extend": "— Move selection (hold Shift to extend)",
      "interpolate_2d_entire_selected_area": "— Interpolate 2D (entire selected area)",
      "select_a_dry_or_wet_shot_system_under": "Select a Dry or Wet Shot System under",
      "10003_launch_control_two_step": "&#10003; Launch control &amp; two-step",
      "add_subtract_1_from_selected_cells": "— Add / subtract 1 from selected cells",
      "target_voltage_v_rpm_vs_map_kpa": "Target Voltage (V) — RPM vs MAP (kPa)",
      "to_get_them": "to get them!",
      "metric_c_kpa_kph": "Metric (°C &middot; kPa &middot; KPH)",
      "10003_knock_detection_retard": "&#10003; Knock detection &amp; retard",
      "ms_adder_dtps_s_vs_rpm_ms": "MS Adder (dTPS %/s vs RPM &rarr; ms)",
      "to_qualify": "to qualify.",
      "10003_everything_in_simple_plus": "&#10003; Everything in Simple, plus:",
      "10003_accel_enrichment_ms_map": "&#10003; Accel enrichment (ms / MAP)",
      "tps_5_rpm_near_idle_target": "(TPS &lt; 5%, RPM near idle target)",
      "10003_dyno_drag_simulation": "&#10003; Dyno &amp; Drag simulation",
      "10003_coil_dwell_misfire_physics": "&#10003; Coil dwell misfire physics",
      "10003_vvt_vvl_cam_control": "&#10003; VVT &amp; VVL cam control",
      "10003_closed_loop_boost_control": "&#10003; Closed-loop boost control",
      "calibrated_center_frequency": "✓ Calibrated — center frequency:",
      "need_some_mods_head_over_to_the": "Need some mods? Head over to the",
      "10003_datalogging_csv_export": "&#10003; Datalogging (CSV export)",
      "10003_o2_sensor_delay_modeling": "&#10003; O2 sensor delay modeling",
      "10003_drag_racing_leaderboards": "&#10003; Drag racing leaderboards",
      "click_here_to_get_advanced_mode": "Click Here to get Advanced Mode →",
      "dont_show_again": "Don't show again",
      "map_load_axis_16_points_kpa": "MAP / Load Axis (16 points, kPa)",
      "flex_fuel_boost_duty_adder": "Flex Fuel Boost Duty Adder (%)",
      "10003_basic_closed_loop_afr": "&#10003; Basic closed-loop AFR",
      "click_here_to_browse_engines": "Click Here to browse Engines →",
      "idle_duty_vs_coolant_temp": "Idle Duty vs Coolant Temp (%)",
      "10003_tune_import_export": "&#10003; Tune import / export",
      "10003_smart_alternator_pid": "&#10003; Smart alternator PID",
      "no_nitrous_system_installed": "No nitrous system installed.",
      "10003_fuel_pressure_model": "&#10003; Fuel pressure model",
      "click_here_to_browse_mods": "Click Here to browse Mods →",
      "edit_a_tuning_table_value": "— Edit a tuning table value",
      "iat_timing_retard_by_iat": "IAT Timing Retard (by IAT",
      "vvl_high_cam_min_tps": "VVL / High Cam Min TPS (%)",
      "10003_idle_ignition_pid": "&#10003; Idle ignition PID",
      "extra_engines_mods": "Extra Engines &amp; Mods",
      "then_reload_this_page": ", then reload this page.",
      "hold_to_rev_the_engine": "— Hold to rev the engine",
      "ect_fuel_enrichment": "ECT Fuel Enrichment (×)",
      "10003_decel_fuel_cut": "&#10003; Decel fuel cut",
      "flex_fuel_ve_adder": "Flex Fuel VE Adder (%)",
      "iat_ve_comp_by_iat": "IAT VE Comp% (by IAT",
      "min_tps_to_engage": "Min TPS to Engage (%)",
      "vvl_fuel_adder_ve": "VVL Fuel Adder (VE %)",
      "voltage_regulator_pid": "Voltage Regulator PID",
      "relative_humidity": "Relative Humidity (%)",
      "modified_violations": "Modified+ violations:",
      "vvl_timing_adder": "VVL Timing Adder (°)",
      "rpm_axis_16_points": "RPM Axis (16 points)",
      "active_session_id": "Active Session ID:",
      "ethanol_content": "Ethanol Content (%)",
      "min_correction": "Min Correction (%)",
      "max_correction": "Max Correction (%)",
      "fuel_adder_afr": "Fuel Adder (AFR %)",
      "fuel_ve_comp": "Fuel VE Comp. (%)",
      "timing_retard": "Timing Retard (°)",
      "9888_red_light": "&#9888; RED LIGHT",
      "and_a_minimum_of": "and a minimum of",
      "timing_locked_in": "Timing Locked In!",
      "1_timeconstant": "1 / timeConstant",
      "throttle_pedal": "— Throttle pedal",
      "5_seconds_ago": "← 5 seconds ago",
      "live_telemetry": "LIVE TELEMETRY",
      "tps_90": "(TPS &gt; 90%)",
      "hold_to_engage": "Hold to Engage",
      "peak_boost": "PEAK BOOST: --",
      "ready_to_stage": "READY TO STAGE",
      "running_mode": "Running Mode",
      "push_to_start": "Push to Start",
      "undo_redo": "— Undo / Redo",
      "to_run_stock": "To run Stock:",
      "not_you": "! Not you? (",
      "firing_order": "FIRING ORDER",
      "deadband": "Deadband (%)",
      "you_must_be": "You must be",
      "simple_mode": "Simple Mode",
      "distributor": "DISTRIBUTOR",
      "n2o_active": "N2O: ACTIVE",
      "fuel_air": "Fuel & Air",
      "vvt_cams": "VVT & Cams",
      "min_tps": "Min TPS (%)",
      "peak_hp": "PEAK HP: --",
      "peak_tq": "PEAK TQ: --",
      "clutch_slip": "CLUTCH SLIP",
      "clutch_fail": "CLUTCH FAIL",
      "vvl_vtec": "VVL / VTEC",
      "idle_mode": "Idle Mode",
      "ref_hp": "REF HP: --",
      "ref_tq": "REF TQ: --",
      "and_using": "and using",
      "decel_cut": "DECEL CUT",
      "ignition": "Ignition",
      "advanced": "Advanced",
      "wot_mode": "WOT Mode",
      "337_hp": "≈ 33.7 HP",
      "got_it": "Got it! ✓",
      "idle_pid": "IDLE PID",
      "timeslip": "TIMESLIP",
      "psi": "-- PSI",
      "setup": "Setup",
      "player": "Player",
      "click": "Click",
      "back": "← Back",
      "25s": "-2.5s",
      "for": "° for",
      "speed": "SPEED",
      "accel": "ACCEL",
      "slip": "SLIP!",
      "time": "TIME",
      "gear": "GEAR",
      "mods": "Mods",
      "tdc": "TDC",
      "mph": "MPH",
      "mod_intake": "Intake",
      "mod_intake_manifold": "Intake Manifold",
      "mod_exhaust_manifold": "Exhaust Manifold",
      "mod_exhaust": "Exhaust",
      "mod_port_and_polish": "Port and Polish",
      "mod_turbocharger": "Turbocharger",
      "mod_supercharger": "Supercharger",
      "mod_camshaft": "Camshaft",
      "mod_pistons": "Pistons",
      "mod_rods": "Rods",
      "mod_clutch": "Clutch",
      "mod_intercooler": "Intercooler",
      "mod_fuel_pump": "Fuel Pump",
      "mod_fuel_injector": "Fuel Injector",
      "stock_none": "Stock / None",
      "dry_shot_system": "Dry Shot System",
      "wet_shot_system": "Wet Shot System",
      "buy_nitrous_kit": "Buy Nitrous Kit!",
      "mod_settings": "Mod Settings",
      "wastegate_spring_psi": "Wastegate Spring (psi)",
      "wastegate_spring_kpa": "Wastegate Spring (kPa)",
      "map_axes_scale_help": "MAP axes scale to 2&times; spring pressure.",
      "closed_loop_boost": "Closed-Loop Boost",
      "pulley_ratio": "Pulley Ratio (SC/Eng)",
      "bypass_threshold": "Bypass Threshold (%)",
      "max_sc_rpm": "Max SC RPM:",
      "twin_turbo_setup": "Twin Turbo Setup",
      "twin_turbo_help": "(&times;1.9 airflow, ~&frac12;&times; spool rate)",
      "custom_transmission": "Custom Transmission",
      "applied": "Applied!",
      "stop_engine": "STOP ENGINE",
      "flooded": "FLOODED",
      "no_start_trigger": "NO START: TRIGGER ANGLE",
      "no_start_lean": "NO START: LEAN",
      "stalled": "STALLED",
      "stalled_rpm": "STALLED: RPM dropped below cranking speed.",
      "stalled_battery": "STALLED: Battery voltage critically low (8 V).",
      "submitting": "Submitting...",
      "submitted": "Submitted!",
      "error_retry": "Error (Retry)"
    }
  }
};